export default function SuccessPage() {
  return (
    <main className="result-shell success-shell">
      <section className="result-card">
        <div className="result-icon success-icon">✓</div>
        <p className="result-kicker">Identity confirmed</p>
        <h1>Verification Successful</h1>
        <p className="result-copy">
          Your liveness check has been completed successfully.
        </p>
      </section>
    </main>
  );
}
